
import { createTheme, Shadows } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        background: {
            default: '#F7F8FA',
            paper: '#ffffff',
        },
        text: {
            primary: '#24292E',
            secondary: '#868F99',
            disabled: '#697386',
        },
        primary: {
            // main: '#32B038',
            light: '#E4FFE5',
            main: '#33B038',
            dark: '',
            contrastText: '#ffffff',
            "50": '#f8fafc',
            "100": "#EFF6FF",
            "300": "#93C5FD",
        },
        secondary: {
            light: '#ECF2FF',
            main: '#2E6BEB',
            contrastText: '#ffffff',
        },
        info: {
            light: '#E9F2FF',
            main: '#247CFF',
            dark: '#00214D',
            contrastText: '#ffffff',
        },
        success: {
            light: '#E5FFF2',
            main: '#1CC266',
            dark: '#004020',
        },
        warning: {
            light: '#FFF8EF',
            main: '#FF8D3A',
            dark: '#400000',
            contrastText: '#ffffff'
        },
        error: {
            light: '#FFF0EB',
            main: '#F31249',
            dark: '#400000',
            contrastText: '#ffffff'
        },
        // divider: "#DCDFE3" //#D7DCE3
        divider: "#D7DCE3" //#D7DCE3
    },
    shadows: [
        'none',
        '0px 4px 8px rgba(0, 0, 0, 0.08)',
        '0px 8px 8px rgba(0, 0, 0, 0.08)',
        '0px 12px 12px rgba(0, 0, 0, 0.08)',
        '0px 0px 6px rgba(0, 0, 0, 0.2)',
    ].concat(Array(21).fill('none')) as Shadows,
    typography: {
        h1: {
            fontWeight: 500,
            fontSize: '2rem',
            color: '#15161A',
        },
        h2: {
            fontWeight: 500,
            fontSize: '1.75rem',
        },
        h4: {
            fontWeight: 500,
            fontSize: '1.25rem',
            color: '#15161A',
        },
        h5: {
            fontWeight: 500,
            fontSize: '1rem',
            color: '#15161A',
        },
        body2: {
            fontWeight: 500,
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
            color: '#3E434A'
        },
        subtitle1: {
            fontWeight: 400,
            fontSize: '0.75rem',
            lineHeight: '1.125rem',
            color: '#88919E'
        },
        subtitle2: {
            fontSize: '10px',
            fontWeight: 800,
            lineHeight: '16px',
        },
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
    },
    components: {
        MuiTextField: {
            defaultProps: {
                size: 'small',
                margin: 'normal',
                fullWidth: true,
                color: 'secondary',
            },
            // styleOverrides: {
            //     root: {
            //         backgroundColor: 'pink',
            //         "& .Mui-error": {
            //             color: 'purple',
            //         },
            //         "& .MuiInputLabel-root": {
            //             color: 'yellow',
            //         },
            //         "& .MuiFormHelperText-root": {
            //             color: 'purple',
            //         }
            //     }
            // },
        },
        MuiSelect: {
            defaultProps: {
                color: 'secondary',
            }
        },
        MuiInputLabel: {
            defaultProps: {
                color: 'secondary',
            }
        },
        MuiDrawer: {
            defaultProps: {
                variant: 'permanent',
                anchor: 'left',
            },
            styleOverrides: {
                root: {
                    width: '16rem',
                    flexShrink: 0,
                    padding: '1rem 0',

                    '& .MuiDrawer-paper': {
                        width: '16rem',
                        backgroundColor: "#ffffff",
                        boxSizing: 'border-box',
                        padding: '0 1rem',
                    },
                }
            }
        },
        MuiChip: {
            defaultProps: {
                size: 'small'
            },
            styleOverrides: {
                sizeSmall: {
                    fontSize: '0.75rem',
                    px: '0.25rem',
                    fontWeight: 500,
                },
                root: {
                    "&.MuiChip-colorInfo": {
                        color: '#247CFF',
                        backgroundColor: '#E9F2FF',
                    },
                    "&.MuiChip-colorSuccess": {
                        color: '#1CC266',
                        backgroundColor: '#E5FFF2',
                    },
                    "&.MuiChip-colorWarning": {
                        color: '#FF8D3A',
                        backgroundColor: '#FFF8EF',
                    },
                    "&.MuiChip-colorError": {
                        color: '#FF3C3C',
                        backgroundColor: '#FFF0EB',
                    }
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '0.5rem',
                    textTransform: 'none',
                    fontSize: '1rem'
                }
            }
        },
        MuiToggleButtonGroup: {
            styleOverrides: {
                root: {
                    gap: '1px',
                }
            }
        },
        MuiListItem: {
            defaultProps: {
                disablePadding: true
            },
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    borderRadius: '0.5rem',
                    border: 0,

                    '&.MuiToggleButton-sizeLarge': {
                        borderRadius: '1.25rem !important',
                        fontSize: '0.875rem',
                        textTransform: 'none',
                        padding: '0.625rem 1rem',
                    },
                    '&.MuiToggleButton-sizeSmall': {
                        borderRadius: '0.5rem !important',
                        fontSize: '0.875rem',
                        textTransform: 'none',
                        padding: '0.5rem 0.875rem',
                    },
                }
            }
        },
        MuiFormControl: {
            defaultProps: {
                size: 'small'
            }
        },
        MuiCard: {
          styleOverrides: {
            root: {
              borderRadius: '1rem',
              border: 1,
              borderColor: 'divider',
              backgroundColor: 'background.paper',
              padding: 16
            }
          }
        }
    }
});

export default theme;